<template>
    <a-spin :tip="loadingTip" :spinning="isloading">
      <div>
        <div class style="position: relative;" :getContainer="handleScollMain">
          <a-form :form="form" @submit="handleSubmit" style="width: 100%;">
            <a-divider id="basicInfo" orientation="left">基本信息</a-divider>
            <a-form-item label="课程名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input placeholder="请输入课程名称" v-decorator="[
                'name',
                { rules: [{ required: true, message: '请输入课程名称!' }], initialValue: info.name }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="课程介绍" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <vue-ueditor-wrap v-model="info.introduce" :config="myConfig"></vue-ueditor-wrap>
            </a-form-item>
  
            <!-- <a-form-item label="课程分类" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-cascader placeholder="请选择" :options="treeData" changeOnSelect @change="treeChange" allowClear v-decorator="[
                'type',
                { rules: [{ required: true, message: '请选择课程分类!' }], initialValue: info.type }
              ]" :fieldNames="{ label: 'name', value: 'id', children: 'children' }"/>
            </a-form-item> -->
            <a-form-item label="课程分类" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-cascader placeholder="请选择" :options="treeData"  @change="treeChange" allowClear  v-decorator="[
                'type',
                { rules: [{ required: true, message: '请选择课程分类!' }], initialValue: info.type }
              ]"  :value="info.type" :fieldNames="{ label: 'name', value: 'id', children: 'children' }"/>
            </a-form-item>
            <a-form-item label="课程类型" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select v-decorator="[
                'nature_type',
                { rules: [{ required: true, message: '请选择课程类型!' }], initialValue: info.nature_type }
              ]" placeholder="请选择" v-model="info.nature_type">
                <a-select-option :value="info.value" v-for="(info, index) in natureTypeList" :key="index">{{ info.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
  
            <a-form-item v-if="info.nature_type === 1" label="课程年份" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input placeholder="请输入课程年份" v-decorator="[
                'year',
                { rules: [], initialValue: info.year }
              ]"></a-input>
            </a-form-item>
  
            <a-form-item label="主讲教师" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select show-search :filter-option="filterOption" v-decorator="[
                'teacherId',
                { rules: [{ required: true, message: '请选择主讲教师!' }], initialValue: info.teacherId }
              ]" placeholder="请选择主讲教师" @change="teacherChange">
                <a-select-option :value="info.id" v-for="(info, index) in teacherlist" :key="index">{{ info.fullName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="课程排序" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input-number placeholder="请输入课程排序,值越大，排序越靠前" v-decorator="[
                'sort',
                { rules: [{ required: false, message: '请输入课程排序,值越大，排序越靠前!' }], initialValue: info.sort }
              ]"></a-input-number>
            </a-form-item>
  
            <a-form-item label="课程有效期" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select v-decorator="[
                'ordereffective',
                { rules: [{ required: false, message: '请选择课程有效期!' }], initialValue: info.ordereffective }
              ]" placeholder="请选择">
                <a-select-option :value="info.itemValue" v-for="(info, index) in useValiditylist" :key="index">{{
                  info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="使用有效期" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select v-decorator="[
                'fronteffective',
                { rules: [{ required: false, message: '请选择使用有效期!' }], initialValue: info.fronteffective }
              ]" placeholder="请选择">
                <a-select-option :value="info.itemValue" v-for="(info, index) in useValiditylist" :key="index">{{
                  info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
  
            <a-form-item label="课程来源" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-select v-model="info.coursefrom" allowClear placeholder="请选择" v-decorator="[
                'coursefrom',
                { rules: [{ required: true, message: '请选择课程来源!' }], initialValue: info.coursefrom }
              ]">
                <a-select-option :value="info.id" v-for="(info, index) in courseFromlist" :key="index">{{ info.itemName }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              v-if="info.coursefrom === 698 || info.coursefrom === 709 || info.coursefrom === 711 || info.coursefrom === 716 || info.coursefrom === 717 || info.coursefrom === 719 || info.coursefrom === 723"
              label="第三方课程ID" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input placeholder="请输入第三方课程ID" v-decorator="[
                'cid',
                { rules: [{ required: info.coursefrom === 698, message: '请输入课程名称!' }], initialValue: info.cid }
              ]"></a-input>
            </a-form-item>
            <a-upload name="file" :multiple="true" :action="$api.file.uploadFile" @change="handleEditorChange"
              class="uploadImage" style="display:none">
              <a-button>
                <a-icon type="upload" />
                Click to Upload
              </a-button>
            </a-upload>
            <a-upload name="file" :multiple="true" :action="$api.file.uploadFile" @change="handleEditorChange2"
              class="uploadImage2" style="display:none">
              <a-button>
                <a-icon type="upload" />
                Click to Upload
              </a-button>
            </a-upload>
  
            <a-divider id="goodsphoto" orientation="left">课程图片</a-divider>
  
            <a-form-item label="图片" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-upload :action="$api.file.uploadFile" listType="picture-card" :fileList="fileList" @preview="handlePreview"
                @change="handleChange">
                <div v-if="fileList.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload>
              <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                <img alt="example" style="width: 100%" :src="previewImage" />
              </a-modal>
              建议尺寸:260像素*160像素
            </a-form-item>
            <a-form-item label="附件" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-upload :action="$api.file.uploadFile" accept=".pdf" :default-file-list="defaultFileList"
                @change="handleChangeEnclosure">
                <a-button> <a-icon type="upload" /> 上传 </a-button>
              </a-upload>
            </a-form-item>
            <a-divider id="goodsphoto" orientation="left">预告片</a-divider>
  
            <a-form-item label="视频" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-upload :action="$api.file.uploadFile" :customRequest="onFileChange" :fileList="fileListVideo"
                listType="picture-card" :beforeUpload="beforeUpload" @preview="handleVideoPreview"
                @change="handleVideoChange">
                <div v-if="fileListVideo.length < 1">
                  <a-icon type="plus" />
                  <div class="ant-upload-text">Upload</div>
                </div>
              </a-upload>
              <a-modal :visible="previewVideoVisible" :footer="null" @cancel="handleVideoCancel">
                <img alt="example" style="width: 100%" :src="previewVideo" />
              </a-modal>
            </a-form-item>
  
            <a-divider id="classHour" orientation="left">价格设置</a-divider>
            <a-form-item label="课程原价" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input placeholder="请输入课程原价" v-decorator="[
                'originalPrice',
                { rules: [{ required: true, message: '请输入课程原价!' }], initialValue: info.originalPrice }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="课程现价" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input placeholder="请输入课程现价" v-decorator="[
                'presentPrice',
                { rules: [{ required: true, message: '请输入课程现价!' }], initialValue: info.presentPrice }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="积分" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-input placeholder="请输入积分" v-decorator="[
                'jifen',
                { rules: [{ required: false, message: '请输入积分!' }], initialValue: info.jifen }
              ]"></a-input>
            </a-form-item>
            <a-form-item label="是否免费" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-switch @change="gratisChange" v-decorator="[
                'isGratis',
                { valuePropName: 'checked', initialValue: info.isGratis }
              ]" />
            </a-form-item>
            <a-form-item label="是否支持试看" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
              <a-switch v-decorator="[
                'isTryToSee',
                { valuePropName: 'checked', initialValue: info.isTryToSee }
              ]" />
            </a-form-item>
            <a-form-item label="数据权限" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
              <pxkeji-btn @click="showSetting" name="设置" type="small" />
            </a-form-item>
  
            <a-divider id="basicInfo" orientation="left" v-if="info.id > 0">课程地址</a-divider>
            <a-form-item label="教师地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" v-if="info.id > 0">
              <span>{{ showTeacherUrl(1) }}</span>
              <span style="margin-left: 10px;color: blue;" @click="copy(showTeacherUrl(1))">复制</span>
            </a-form-item>
            <a-form-item label="学生地址" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" v-if="info.id > 0">
              <span>{{ showTeacherUrl(0) }}</span>
              <span style="margin-left: 10px;color: blue;" @click="copy(showTeacherUrl(0))">复制</span>
            </a-form-item>
  
            <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
              <pxkeji-btn name="保存" type="primary" htmlType="submit" />
              <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
            </a-form-item>
          </a-form>
        </div>
        <a-modal title="权限设置" v-model="authorInfo.visible" width="60%" :footer="false" destroyOnClose :maskClosable="false">
          <authoritySettingInfo :id="this.id" @callbackMethod="serCourseAuthor" />
        </a-modal>
  
      </div>
    </a-spin>
  </template>

  <script>
  export default {
    
  }
  </script>
  
  <script>
  import authoritySettingInfo from "./authoritySettingInfo";
  import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
  var that;
  var thisInfo = [];
  export default {
    props: {
      id: String,
      cInfo: {
        type: Object,
        default: () => {
        },
      },
    },
    data() {
      return {
        form: this.$form.createForm(this),
        dis: this.disabled,
        info: {
          status: true,
          type: [0],
          originalPrice: "",
          presentPrice: "",
          isGratis: true,
          isTryToSee: true,
          areaList: "",
          adminList: "",
          enterList: "",
          nature_type: '',
          year: '',
          sort: 0
        },
        defaultValue_courseType:[],
        authorInfo: {
          visible: false,
          id: 0
        },
        treeData: [],
        fileList: [],
        fileListVideo: [],
        previewVisible: false,
        previewVideoVisible: false,
        previewImage: "",
        picArr: [],
        videoArr: [],
        previewVideo: "",
        isloading: false,
        loadingTip: "加载中...",
        regionDatas: [],
        courseValiditylist: [
          { id: 1, name: "一个月" },
          { id: 2, name: "三个月" },
          { id: 3, name: "六个月" },
        ],
        courseSourcelist: [],
        columnlist: [],
        courseFromlist: [],
        useValiditylist: [],
        LevelDatas: [],
        content: "",
        teacherlist: [],
        teacherlistNow: [],
        myConfig: {
          // 编辑器不自动被内容撑高
          autoHeightEnabled: false,
          // 初始容器高度
          initialFrameHeight: 400,
          // 初始容器宽度
          initialFrameWidth: "100%",
          // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
          // serverUrl: this.$api.file.uploadUpFile,
          serverUrl: this.$msg.user.apiUrl + '/Ueditor/upload',
          // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
          UEDITOR_HOME_URL: "/UEditor/",
          toolbars:[['fullscreen', 'source', '|', 'undo', 'redo', '|','bold', 'italic', 'underline', 'fontborder', 'strikethrough', 'superscript', 'subscript', 'removeformat', 'formatmatch', 'blockquote', 'pasteplain', '|', 'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', 'selectall', 'cleardoc', '|',
              'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
              'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
              'directionalityltr', 'directionalityrtl', 'indent', '|',
              'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|', 'touppercase', 'tolowercase', '|',
              'link', 'unlink', 'anchor', '|', 'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
              'simpleupload', 'insertimage', '|',
              'horizontal', 'date', 'time', 'spechars', 'snapscreen', '|',
              'inserttable', 'deletetable', 'insertparagraphbeforetable', 'insertrow', 'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright', 'mergedown', 'splittocells', 'splittorows', 'splittocols', 'charts']],
        },
        teacherurl: '',//2021 08 20
        studenturl: '',//2021 08 20
        videoId: '',
        requestId: '',
        uploadAddress: '',
        uploadAuth: null,
        myUploader: null,
        uploadProgress: '',
        textarea: '',
        VideoForm: [],
        videoTimer: null,
        natureTypeList: [{ value: 1, name: '公需课' }, { value: 2, name: '专业课' }], //2021 12 21
        defaultFileList: [], //2022 02 25
        enclosureArr: [], //2022 02 25
      };
    },
    mounted() {
      this.$nextTick( function () {
        that = this;
        this.getTree();
        this.getcolumnlist(); //所属栏目列表
        this.getcourseFromlist(); //课程来源列表
        this.getTeacherlist(); //教师列表
        this.getuseValiditylist(); //有效期列表
        
      });
    },
    components: {
      // zjInfo,
      // ksInfo
      authoritySettingInfo,
      VueUeditorWrap
    },
    methods: {
      // 2022 02 25 start
      handleChangeEnclosure(info) {
        this.defaultFileList = info.fileList;
        if (info.file.status == "done") {
          if (info.file.response.errorCode != "0000") {
            this.error("上传失败");
          }
        } else if (info.file.status == "error") {
          this.error("上传失败");
        }
        if (info.file.status !== 'uploading') {
          console.log(info);
        }
      },
      // 2022 02 25 end
      // 2021 11 09 start
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      // 2021 11 09 end
      //2021 09 17
      onFileChange(files) {
        const fileChooser = files
        if (fileChooser.file) {
  
          const file = fileChooser.file
          const fileName = file.name
          this.VideoForm.fileName = fileName
          this.VideoForm.title = fileName.substring(0, fileName.lastIndexOf('.'))
          this.VideoForm.cate = 0
          this.VideoForm.tags = ''
          this.$api.course.doGetUploadVideo(this.VideoForm.title, this.VideoForm.fileName).then((res) => {
            if (res.errorCode === '0000') {
              this.videoId = res.data.videoId
              this.requestId = res.data.requestId
              this.uploadAddress = res.data.uploadAddress
              this.uploadAuth = res.data.uploadAuth
  
              this.getUpload(file)
  
            } else {
              this.$message.success('获取上传认证失败!');
            }
          })
  
  
        }
  
  
      },
      isVodMode() {
        return (this.uploadAuth && this.uploadAuth.length > 0)
      },
      getUpload(file) {
  
        if (this.myUploader === null) {
          console.log('this.myUploader', this.myUploader)
          /* eslint no-undef: "off" */
          this.myUploader = new AliyunUpload.Vod({
            userId: "122",
            // 分片大小默认1M
            partSize: 1048576,
            // 并行上传分片个数，默认5
            parallel: 5,
            // 网络原因失败时，重新上传次数，默认为3
            retryCount: 3,
            // 网络原因失败时，重新上传间隔时间，默认为2秒
            retryDuration: 2,
            // 文件上传失败
            'onUploadFailed': (uploadInfo, code, message) => {
              this.$message.error('视频上传失败');
  
            },
            // 文件上传完成
            'onUploadSucceed': (uploadInfo) => {
              console.log(uploadInfo);
              var _this = this;
              this.isloading = true;
              this.loadingTip = "转码中...";
              this.videoTimer = setInterval(res => {
                if (_this.getVideoInfo()) {
                  _this.$message.success('视频上传成功!');
                }
              }, 2000)
  
              // _this._doContinueAdd() // --------------上传成功后，把数据给后台
            },
            // 文件上传进度
            'onUploadProgress': (uploadInfo, totalSize, loadedPercent) => {
              var fileitem = this.fileListVideo[0];
              fileitem.percent = Math.ceil(loadedPercent * 100);
              this.fileListVideo[0] = fileitem;
  
              console.log('onUploadProgress:file:' + uploadInfo.file.name + ', fileSize:' + totalSize + ', percent:' + Math.ceil(loadedPercent * 100) + '%')
  
            },
            // STS临时账号会过期，过期时触发函数
            'onUploadTokenExpired': () => {
              this.log('onUploadTokenExpired')
              if (this.isVodMode()) {
                // 实现时，从新获取UploadAuth
                this.myUploader.resumeUploadWithAuth(this.uploadAuth)
              }
            },
            // 开始上传
            'onUploadstarted': (uploadInfo) => {
              console.log('开始上传');
              if (this.isVodMode()) {
                this.myUploader.setUploadAuthAndAddress(uploadInfo,
                  this.uploadAuth, this.uploadAddress)
              }
              console.log('onUploadStarted:' + uploadInfo.file.name + ', endpoint:' + uploadInfo.endpoint + ', bucket:" + uploadInfo.bucket + ", object:' + uploadInfo.object + uploadInfo.userDate)
            }
          })
        }
        if (this.isVodMode()) {
          this.myUploader.init() // 点播上传。每次上传都是独立的鉴权，所以初始化时，不需要设置鉴权
        }
        var userData = '{"Vod":{}}'
        // 点播上传。每次上传都是独立的OSS object，所以添加文件时，不需要设置OSS的属性
        // console.log(this.myUploader.addFile);
        this.myUploader.addFile(file, null, null, null, userData)
        console.log('开始上传---');
        this.myUploader.startUpload()
      },
      getVideoInfo() {
        this.$api.course.getVideoInfo(this.videoId).then((res) => {
          if (res.errorCode === '0000') {
            var fileitem = this.fileListVideo[0];
            this.videoArr = [];
            fileitem.url = res.data.playURL;
            fileitem.percent = 100;
            fileitem.status = 'done';
            this.isloading = false;
            this.loadingTip = "加载中...";
            this.fileListVideo[0] = fileitem;
            clearInterval(this.videoTimer);
            return true;
          }
        })
      },
      // 2021 09 17 end
      // 2021 08 20 start
      showTeacherUrl(status) {
  
        var baseHost = window.location.host;
        var baseArr = baseHost.split(".");
        if (baseArr[1] == 'admin') {
          baseArr.splice(1, 1);
        }
        var courseurl = baseArr.join(".");
        if (status == 1) {
          return window.location.protocol + "//" + courseurl + '/p_teacheraddcourse.html?id=' + this.id;//2022 01 10
        } else {
          return window.location.protocol + "//" + courseurl + '/p_xuexi.html?id=' + this.id; //2022 01 10
        }
  
  
      },
      copy(data) {
        let url = data;
        let oInput = document.createElement('input');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        console.log(oInput.value)
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success('复制成功');
        oInput.remove()
      },
      // 2021 08 20 end
      showSetting() {
        this.authorInfo.visible = true;
      },
      serCourseAuthor(admin, area, enter) {
        this.authorInfo.visible = false;
        this.info.adminList = admin;
        this.info.areaList = area;
        this.info.enterList = enter;
      },
      gratisChange(v) {
        this.form.resetFields(["originalPrice, presentPrice"]);
        if (v) {
          this.info.originalPrice = "";
          this.info.presentPrice = "";
        } else {
          this.info.originalPrice = null;
          this.info.presentPrice = null;
        }
        this.info.isGratis = v;
      },
      /**取消 */
      cancelClick() {
        this.$emit("callbackMethod");
      },
      sumbit() {
        this.$emit("callbackMethod");
      },
      treeChange(val) {
        console.log("执行了这个方法")
        this.info.type = val;
      },
      onRangeChange(value, dateString) {
        this.info.startTime = dateString[0];
        this.info.endTime = dateString[1];
      },
      /**获取字典子项 */
      getcolumnlist() {
        //获取列表
        this.isloading = true;
        this.$api.dictionaryItem
          .getDictionaryItem(1)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.columnlist = res.data;
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      },
      getcourseFromlist() {
        //获取列表
        this.isloading = true;
        this.$api.dictionaryItem
          .getDictionaryItem(2)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.courseFromlist = res.data;
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      },
      getuseValiditylist() {
        //获取列表
        this.isloading = true;
        this.$api.dictionaryItem
          .getDictionaryItem(11)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.useValiditylist = res.data;
  
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      },
      //分类
      getTree() {
        this.$api.courseType
          .getTreeByColumnId("", "")
          .then((res) => {
            if (res.errorCode == this.$msg.responseCode.success) {
              var allData = [
                {
                  name: "根目录",
                  parentid: 0,
                  id: 0,
                  children: res.data,
                },
              ];
              this.treeData = allData;
              console.log("treeData",this.treeData)
              this.info.type = [0];
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          })
          .finally(()=>{
            if (this.id != 0) {
            //编辑
            this.getInfo();
            }
          });
      },
      /**回显栏目 */
      getParentChain(id) {
        this.$api.courseType
          .getParentIdList(id)
          .then((res) => {
            if (res.errorCode == this.$msg.responseCode.success) {
              var infoSel = res.data;
              infoSel.unshift(0);
              this.info = thisInfo;
              this.info.coursecolumn = Number(thisInfo.coursecolumn);
              this.info.type = infoSel;
             this.defaultValue_courseType = infoSel
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      },
      //详情
      getInfo() {
        this.isloading = true;
        this.$api.course
          .getById(this.id)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
  
              if (res.data.type) {
                this.info.isGratis = this.$commen.changeIntBoolean(
                  res.data.isGratis
                );
                this.info.isTryToSee = this.$commen.changeIntBoolean(
                  res.data.isTryToSee
                );
                thisInfo = res.data;
                this.getParentChain(res.data.type);
              } else {
                this.info = res.data;
                this.info.type = [0];
              }
  
              this.info.coursefrom = res.data.coursefrom;
              this.info.coursecolumn = res.data.coursecolumn;
              // console.log(this.info.coursecolumn)
  
              //  console.log(this.info.isGratis)
              if (res.data.picUrl.length > 0) {
                var pics = res.data.picUrl.split(",");
                for (var i = 0; i < pics.length; i++) {
                  this.fileList.push({
                    uid: i,
                    name: "课程图片" + (i + 1) + ".png",
                    status: "done",
                    url: pics[i],
                  });
                }
              }
  
              if (res.data.videoUrl) {
                var videos = res.data.videoUrl.split(",");
                for (var i = 0; i < videos.length; i++) {
                  this.fileListVideo.push({
                    uid: i,
                    name: "课程视频" + (i + 1) + ".png",
                    status: "done",
                    url: videos[i],
                  });
                }
                // 2021 09 22 start
              } else {
                if (res.data.videoId.length > 1) {
  
                  this.getVideoInfo();
                }
                // 2021 09 22 end
              }
              // 2022 02 25 start
              if (res.data.enclosure) {
                var enclosures = res.data.enclosure.split(",");
                for (var i = 0; i < enclosures.length; i++) {
                  var name = enclosures[i].slice(enclosures[i].lastIndexOf('/') + 1, enclosures[i].lastIndexOf('.pdf') + 4);
                  this.defaultFileList.push({
                    uid: i,
                    name: name,
                    status: "done",
                    url: enclosures[i],
                  });
                }
              }
              // 2022 02 25 end
              this.videoId = res.data.videoId;// 2021 09 22
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
      },
      //获取教师列表
      getTeacherlist() {
        this.isloading = true;
        this.$api.trainClass
          .getTeacherList(name)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.teacherlist = res.data;
            } else {
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
            this.error();
          });
      },
      //教师选择
      teacherChange(value) {
        if (value) {
          this.dis = false;
          // this.getGrouplist(value);
          this.getTeacherlist(value);
        }
      },
      searchChange(s) {
  
        if (s != "") {
          this.teacherlistNow = [];
          for (var i = 0; i < this.teacherlist.length; i++) {
            if (this.teacherlist[i].userName) {
              if (this.teacherlist[i].userName.indexOf(s) > -1) {
                this.teacherlistNow.push(this.teacherlist[i]);
  
              }
            }
          }
        }
  
        //console.log('结果',this.teacherlistNow)
      },
      handleSubmit(e) {
        e.preventDefault();
        this.picArr = [];
        for (var i = 0; i < this.fileList.length; i++) {
          if (this.fileList[i].url) {
            this.picArr.push(this.fileList[i].url);
          } else if (this.fileList[i].response.data.path) {
            this.picArr.push(this.fileList[i].response.data.path);
          }
        }
        this.videoArr = [];
        for (var i = 0; i < this.fileListVideo.length; i++) {
          if (this.fileListVideo[i].url) {
            this.videoArr.push(this.fileListVideo[i].url);
          } else if (this.fileListVideo[i].response.data.path) {
            this.videoArr.push(this.fileListVideo[i].response.data.path);
          }
        }
        // 2022 02 25 start
        this.enclosureArr = [];
        for (var i = 0; i < this.defaultFileList.length; i++) {
          if (this.defaultFileList[i].url) {
            this.enclosureArr.push(this.defaultFileList[i].url);
          } else if (this.defaultFileList[i].response.data.path) {
            this.enclosureArr.push(this.defaultFileList[i].response.data.path);
          }
        }
        // 2022 02 25 end
        // console.log("=====this.info=====>",this.info);
        // return;
        this.form.validateFields((err, values) => {
          if (!err) {
            if (this.info.type.length == 1) {
              this.$message.error("请选择课程分类");
              return;
            }
            if (values.isGratis) {
              values.originalPrice = "";
              values.presentPrice = "";
            } else {
              if (values.originalPrice == null || values.originalPrice == "") {
                this.$message.error("请填写课程原价");
                return;
              }
              if (values.presentPrice == null || values.presentPrice == "") {
                this.$message.error("请填写课程现价");
                return;
              }
            }
            if (this.id != 0) {
              //修改
              this.isloading = true;
              this.$api.course
                .update(
                  this.id,
                  values.name,
                  this.info.type[this.info.type.length - 1],
                  this.info.introduce ? this.info.introduce : "",
                  values.teacherId,
                  values.teacherIntroduce ? values.teacherIntroduce : "",
                  0,
                  values.fronteffective ? values.fronteffective : "",
                  values.ordereffective ? values.ordereffective : "",
                  values.coursefrom ? values.coursefrom : "",
                  1,
                  this.info.pccontent ? this.info.pccontent : "",
                  this.info.appcontent ? this.info.appcontent : "",
                  this.picArr ? this.picArr.join(",") : "",
                  this.videoArr ? this.videoArr.join(",") : "",
                  values.originalPrice ? values.originalPrice : "",
                  values.presentPrice ? values.presentPrice : "",
                  values.jifen ? values.jifen : "",
                  values.isGratis
                    ? this.$commen.changeBooleanInt(values.isGratis)
                    : this.$commen.changeBooleanInt(this.info.isGratis),
                  this.$commen.changeBooleanInt(values.isTryToSee),
                  values.totalTime ? values.totalTime : 1,
                  this.info.areaList ? this.info.areaList : "",
                  this.info.adminList ? this.info.adminList : "",
                  this.info.enterList ? this.info.enterList : "",
                  values.cid ? values.cid : "",
                  this.videoId ? this.videoId : 0,// 2021 09 22
                  this.info.nature_type ? this.info.nature_type : "", //2021 12 21
                  this.enclosureArr ? this.enclosureArr.join(",") : "", //2022 02 25
                  values.year ? values.year : "",
                  values.sort ? values.sort : 0
                )
                .then((res) => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.$message.success(res.errorMsg);
                    this.$emit("callbackMethod");
                    //this.form.resetFields();
                  } else {
                    this.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
            } else {
              //新增
              this.isloading = true;
              this.loadingTip = "保存中...";
              this.$api.course
                .save(
                  values.name,
                  this.info.type[this.info.type.length - 1],
                  this.info.introduce ? this.info.introduce : "",
                  values.teacherId,
                  values.teacherIntroduce ? values.teacherIntroduce : "",
                  0,
                  values.fronteffective ? values.fronteffective : "",
                  values.ordereffective ? values.ordereffective : "",
                  values.coursefrom ? values.coursefrom : "",
                  1,
                  this.info.pccontent ? this.info.pccontent : "",
                  this.info.appcontent ? this.info.appcontent : "",
                  this.picArr ? this.picArr : "",
                  this.videoArr ? this.videoArr : "",
                  values.originalPrice ? values.originalPrice : "",
                  values.presentPrice ? values.presentPrice : "",
                  values.jifen ? values.jifen : "",
                  values.isGratis
                    ? this.$commen.changeBooleanInt(values.isGratis)
                    : this.$commen.changeBooleanInt(this.info.isGratis),
                  values.isTryToSee
                    ? this.$commen.changeBooleanInt(values.isTryToSee)
                    : this.$commen.changeBooleanInt(this.info.isTryToSee),
                  values.totalTime ? values.totalTime : 1,
                  this.info.areaList ? this.info.areaList : "",
                  this.info.adminList ? this.info.adminList : "",
                  this.info.enterList ? this.info.enterList : "",
                  values.cid ? values.cid : "",
                  this.videoId ? this.videoId : '',// 2021 09 22
                  this.info.nature_type ? this.info.nature_type : "", //2021 12 21
                  this.enclosureArr ? this.enclosureArr.join(",") : "", //2022 02 25
                  values.year ? values.year : "",
                  values.sort ? values.sort : 0
                )
                .then((res) => {
                  this.isloading = false;
                  if (res.errorCode == this.$msg.responseCode.success) {
                    this.$message.success(res.errorMsg);
                    this.$emit("callbackMethod");
                    //this.form.resetFields();
                  } else {
                    this.$message.error(res.errorMsg);
                  }
                })
                .catch(() => {
                  this.isloading = false;
                });
            }
          }
        });
      },
      getRegionList() {
        this.isloading = true;
        this.$api.system.dictionaryItem
          .list(1)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.regionDatas = res.data;
  
              this.getLevelList();
            } else {
              //this.$message.error(res.errorMsg);
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
            this.error();
          });
      },
      getLevelList() {
        this.isloading = true;
        this.$api.system.dictionaryItem
          .list(3)
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.LevelDatas = res.data;
              if (this.id) {
                this.info = this.cInfo;
                this.info.status = this.cInfo.status == 1 ? true : false;
              }
            } else {
              //this.$message.error(res.errorMsg);
              this.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
            this.error();
          });
      },
      /**添加章节 */
      addzhangjie() {
        this.zjInfo.visible = true;
      },
      getaddzjInfo(data) {
        this.zjInfo.visible = false;
        this.zjlists.push({
          name: data,
        });
      },
      /**添加课时 **/
      addks() {
        this.ksInfo.visible = true;
      },
      getaddksInfo(data) {
        this.ksInfo.visible = false;
        console.log(data);
      },
      /**上移下移 */
      handlemoveup(index) {
        // this.zjlists.splice(index - 1, 0, this.zjlists[index]);
        // //删除后一项
        // this.zjlists.splice(index + 1, 1);
        // if (index == 0) {
        //   this.$message.warning("已经到顶了!");
        // }
      },
      handlemovedown(index) {
        //在下一项插入该项
        this.zjlists.splice(index + 2, 0, this.zjlists[index]);
        // 删除前一项
        this.zjlists.splice(index, 1);
        item.isShow = false;
        if (index == this.zjlists.length - 1) {
          this.$message.warning("已经是最后一项啦！");
        }
      },
      /**添加课时 */
  
      error(msg) {
        this.$error({
          title: "提示",
          content: msg == undefined ? "服务器异常" : msg,
          okText: "返回",
          centered: true,
          onOk() {
            that.$emit("callbackMethod");
          },
        });
      },
      /**富文本上传图片 */
      handleEditorChange(info) {
        if (info.file.status == "done") {
          if (info.file.response.errorCode == this.$msg.responseCode.success) {
            // 获取富文本组件实例
            let quill = this.$refs.QuillEditor.quill;
            // 如果上传成功
            if (info.file.response.data.path) {
              // 获取光标所在位置
              let length = quill.getSelection().index;
              // 插入图片，res为服务器返回的图片链接地址
              quill.insertEmbed(length, "image", info.file.response.data.path);
              // 调整光标到最后
              quill.setSelection(length + 1);
            } else {
              // 提示信息，需引入Message
              Message.error("图片插入失败");
            }
          }
        }
      },
      /**富文本上传图片 */
      handleEditorChange2(info) {
        if (info.file.status == "done") {
          if (info.file.response.errorCode == this.$msg.responseCode.success) {
            // 获取富文本组件实例
            let quill = this.$refs.QuillEditor2.quill;
            // 如果上传成功
            if (info.file.response.data.path) {
              // 获取光标所在位置
              let length = quill.getSelection().index;
              // 插入图片，res为服务器返回的图片链接地址
              quill.insertEmbed(length, "image", info.file.response.data.path);
              // 调整光标到最后
              quill.setSelection(length + 1);
            } else {
              // 提示信息，需引入Message
              Message.error("图片插入失败");
            }
          }
        }
      },
      /**上传课程图片 */
      handleCancel() {
        this.previewVisible = false;
      },
      handlePreview(file) {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      },
      handleChange(info) {
        this.fileList = info.fileList;
      },
  
      /**上传课程视频 */
      handleVideoCancel() {
        this.previewVideoVisible = false;
      },
      beforeUpload(file) {
        const isMP4 = file.type === "video/mp4";
        if (!isMP4) {
          this.$message.error("You can only upload MP4 file!");
        }
        const isLt1G = file.size / 1024 / 1024 < 1024;
        if (!isLt1G) {
          this.$message.error("Image must smaller than 1GB!");
        }
        return isMP4 && isLt1G;
      },
      handleVideoPreview(file) {
        this.previewVideo = file.url || file.thumbUrl;
        this.previewVideoVisible = true;
      },
      handleVideoChange(info) {
        this.fileListVideo = info.fileList;
        if (info.file.status == "done") {
          if (info.file.response.errorCode != "0000") {
            this.error("上传失败");
          }
        } else if (info.file.status == "error") {
          this.error("上传失败");
        }
      },
      handleScollMain() {
        return document.querySelector(".ant-modal-wrap");
      },
    },
  };
  </script>
  <style>
  .zjitem {
    border: 1px solid #e8e8e8;
    padding-left: 20px;
    cursor: pointer;
    margin-bottom: 10px;
  }
  
  .addzj,
  .moveup,
  .movedown {
    color: #1890ff;
  }
  
  .ant-form-item-control {
    line-height: 20px !important;
  }
  </style>
  